"use strict";
require("./vis");
if (typeof document !== "undefined") {
    require("./lib/renderable/vis/bar3d/Bar3D.scss");
    require("./lib/renderable/vis/doughnut/Doughnut.scss");
    require("./lib/renderable/vis/heatmap/Heatmap.scss");
    require("./lib/renderable/vis/line/Line.scss");
    require("./lib/renderable/vis/scatterplot/Scatterplot.scss");
    require("./lib/renderable/vis/stackedbar/Stackedbar.scss");
    require("./lib/renderable/vis/sunburst/Sunburst.scss");
}
